import styled from 'styled-components';
import { space, layout, flexbox, grid, position, typography } from 'styled-system';
import withErrorHandling from 'enhancers/withErrorHandling';

const Box = withErrorHandling(styled.div((({ theme, fluid }) => `
  ${fluid ? 'width: 100%;' : ''}
`), space, layout, flexbox, position, grid, typography));

export default Box;
